export const PROJECT_ENVIRONMENT_KINDS = ['production', 'staging', 'development', 'preview', 'local'] as const
export const PROJECT_ENVIRONMENT_TRIGGERS = ['manual', 'schedule', 'github-app', 'github-action'] as const

export type ProjectEnvironmentKind = (typeof PROJECT_ENVIRONMENT_KINDS)[number]
export type ProjectEnvironmentTrigger = (typeof PROJECT_ENVIRONMENT_TRIGGERS)[number]

export function inferProjectEnvironmentKind(rawUrl: string): ProjectEnvironmentKind {
  let url: URL
  try { url = new URL(rawUrl) } catch { return 'production' }
  const hostname = url.hostname.toLowerCase()
  const searchable = `${hostname}${url.pathname}`.toLowerCase()
  if (hostname === 'localhost' || hostname === '127.0.0.1' || hostname === '::1' || hostname.endsWith('.localhost')) return 'local'
  if (/(^|[._/-])(staging|stage|stg)([._/-]|$)/.test(searchable)) return 'staging'
  if (/(^|[._/-])(preview|pr-\d+)([._/-]|$)/.test(searchable)) return 'preview'
  if (/(^|[._/-])(development|develop|dev)([._/-]|$)/.test(searchable)) return 'development'
  return 'production'
}

export function environmentNameForKind(kind: ProjectEnvironmentKind): string {
  return kind === 'local' ? 'Local' : kind[0]!.toUpperCase() + kind.slice(1)
}
